// extracted by mini-css-extract-plugin
export var root = "WPPost-module--root--a215d";